export async function DiagramToggle($toggle, callback) {
    // this will toggle the .active class of a targeted element (and its trigger) via a separate trigger (e.g. button)
    // basic usage
    //  - add a class to your target element (e.g. .js-my-target)
    //  - add the .js-toggle class to your trigger element
    //  - add the data-toggle-target=".js-my-target" attribute to trigger element and set the value to match the class on your target element
    
    callback = callback || null;
    var targetVal = $toggle.data('toggle-target');
    var $targetElement = $(targetVal);
    // find all triggers with a related target (data-target attribute)
    var $triggerElements = $('[data-toggle-target="' + targetVal + '"]');
    var isActive = $targetElement.hasClass('active') ? true : false;

    if (isActive) {
        $triggerElements.removeClass('active');
        $targetElement.removeClass('active');
        isActive = false;
    } else {
        $triggerElements.addClass('active');
        $targetElement.addClass('active');
        isActive = true;
    }

    $triggerElements.blur();

    if (callback != null) {
        return callback(isActive);
    }
}